<template>
  <v-app-bar app :color="getColor" dark>
    <img :lazy-src="getLogo" height="50" class="me-5" :src="getLogo" />
    <v-toolbar-title>{{ getTitle }}</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" icon v-on="on" v-show="getUser.username">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="logout">
          <v-list-item-title>Ելք</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
// import axios from "axios";

export default {
  name: "Navbar",
  data: () => {
    return {
      url: process.env.VUE_APP_STRAPI_URL,
      layout: {},
    };
  },

  computed: {
    ...mapGetters(["getUser", "layoutGetter"]),

    getLogo() {
      if (Object.keys(this.layout).length > 0) {
        return this.url + this.layout.attributes.logourl;
      }
      return `https://cdn.worldvectorlogo.com/logos/ieee-light.svg`;
    },

    getTitle() {
      if (Object.keys(this.layout).length > 0) {
        this.updateTitle(this.layout.attributes.title);
        return this.layout.attributes.title;
      }
      return "";
    },

    getColor() {
      if (Object.keys(this.layout).length > 0) {
        return `rgb(${this.layout.attributes.color})`;
      }
      return "";
    },
  },

  watch: {
    layoutGetter(newValue) {
      this.layout = newValue;
    },
  },

  methods: {
    ...mapMutations(["updateLayout", "updateTitle"]),
    ...mapActions(["checkUser"]),

    async getLayout() {
      await fetch(this.url + "/api/homelayout")
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          console.log(data.data, "dataaaaaa");
          this.layout = data.data;
          this.updateLayout(this.layout);
        })
        .catch((e) => {
          console.log(e);
          // commit("layoutMutation", e);
        });
    },
    logout() {
      let user = {};
      this.checkUser(user);
      localStorage.removeItem("dbAccess");
      localStorage.removeItem("EnableSynonymsDetection");
      localStorage.removeItem("EnableTechnicalTrickDetection");
      window.localStorage.removeItem("jwt");
      window.localStorage.removeItem("userData");
      this.$router.push("/login");
    },
  },
  mounted() {
    this.getLayout();
    // if (Object.keys(this.getUser).length > 0) {
    //   this.getLayout();
    // }
  },
};
</script>
